module.exports = __webpack_public_path__ + "img/siracusa_hero_card.be81dbfe.png";